module.exports = __webpack_public_path__ + "img/study-pro4.5f8b016e.png";